import CONFIG from '../config';

const telegram = window.Telegram?.WebApp ?? null;
const REEL_START_PARAM_PREFIX = 'reel_';

export const DEFAULT_START_PARAMS = {
  affiliateId: null,
  influencerId: null,
  reelId: null,
};

export const getTelegramWebApp = () => telegram;

export const isTelegramWebApp = () => Boolean(telegram?.initData);

export const getSafeAreaInset = () =>
  telegram?.safeAreaInset ?? {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };

export const triggerHaptic = () => {
  telegram?.HapticFeedback?.impactOccurred('medium');
};

export const getTelegramStartParam = () => {
  const telegramStartParam = telegram?.initDataUnsafe?.start_param;

  if (telegramStartParam) {
    return telegramStartParam;
  }

  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('tgWebAppStartParam') || searchParams.get('startapp') || null;
};

export const parseTelegramStartParam = startParam => {
  if (!startParam) {
    return DEFAULT_START_PARAMS;
  }

  if (startParam.startsWith(REEL_START_PARAM_PREFIX)) {
    return {
      ...DEFAULT_START_PARAMS,
      reelId: startParam.slice(REEL_START_PARAM_PREFIX.length) || null,
    };
  }

  const parts = startParam.split('__');

  if (parts.length === 2) {
    return {
      ...DEFAULT_START_PARAMS,
      influencerId: parts[0] || null,
      affiliateId: parts[1] || null,
    };
  }

  if (startParam.startsWith('__')) {
    return {
      ...DEFAULT_START_PARAMS,
      affiliateId: startParam.slice(2) || null,
    };
  }

  return {
    ...DEFAULT_START_PARAMS,
    influencerId: startParam,
  };
};

export const buildReelStartParam = reelId => `${REEL_START_PARAM_PREFIX}${reelId}`;

export const buildMiniAppUrl = startParam => {
  const botUsername = CONFIG.TELEGRAM.BOT_USERNAME?.replace(/^@/, '');

  if (!botUsername) {
    return window.location.href;
  }

  const url = new URL(`https://t.me/${botUsername}`);

  if (startParam) {
    url.searchParams.set('startapp', startParam);
  }

  return url.toString();
};

export const openTelegramLink = url => {
  if (telegram?.openTelegramLink) {
    telegram.openTelegramLink(url);
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};

export const shareToTelegramStory = (mediaUrl, params) => {
  if (!telegram?.shareToStory || !mediaUrl) {
    return false;
  }

  telegram.shareToStory(mediaUrl, params);
  return true;
};
